import { render, staticRenderFns } from "./LoginToSIS.vue?vue&type=template&id=710f6550&scoped=true&"
import script from "./LoginToSIS.vue?vue&type=script&lang=js&"
export * from "./LoginToSIS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710f6550",
  null
  
)

export default component.exports